import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Callback from '@/components/Callback';
import Lobby from '@/components/Lobby';
import Game from '@/components/games/Game';
import GameView from '@/components/games/GameView';
import EndedGame from '@/components/ended/EndedGame';
import SetUserNameModale from '@/components/SetUserNameModale';
import Profile from '@/components/profile/Profile';
import ProfileView from '@/components/profile/ProfileView';
import Rating from '@/components/Rating';
import SupportLCT from '@/components/SupportLCT';
import Rules from '@/components/Rules';
import Contact from '@/components/Contact';
import ChangePicture from '@/components/profile/ChangePicture';
import MentionsLegales from '@/components/MentionsLegales';
import AdminUsers from '@/components/admin/AdminUsers';
import AdminPayements from '@/components/admin/AdminPayments';
import AdminCognito from '@/components/admin/AdminCognito';
import Statistics from '@/components/admin/Stats';
import PrepareGame from '@/components/games/PrepareGame';
import iam from '../iam';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
    },
    {
      path: '/username',
      name: 'username',
      component: SetUserNameModale,
    },
    {
      path: '/lobby',
      name: 'Lobby',
      component: Lobby,
    },
    {
      path: '/picture',
      name: 'ChangePicture',
      component: ChangePicture,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
    {
      path: '/profiles/:userId',
      name: 'Profiles',
      component: ProfileView,
      props: true,
    },
    {
      path: '/rating',
      name: 'Rating',
      component: Rating,
    },
    {
      path: '/games/:activeGameId',
      name: 'Game',
      component: Game,
      props: true,
    },
    {
      path: '/prepare-games/:activeGameId',
      name: 'PrepareGame',
      component: PrepareGame,
      props: true,
    },
    {
      path: '/view/games/:activeGameId',
      name: 'GameView',
      component: GameView,
      props: true,
    },
    {
      path: '/ended-games/:gameId',
      name: 'EndedGame',
      component: EndedGame,
      props: true,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/support',
      name: 'SupportLCT',
      component: SupportLCT,
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules,
    },
    {
      path: '/mention-legales',
      name: 'MentionsLegales',
      component: MentionsLegales,
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers,
    },
    {
      path: '/admin/payments',
      name: 'AdminPaiements',
      component: AdminPayements,
    },
    {
      path: '/admin/cognitousers',
      name: 'AdminCognito',
      component: AdminCognito,
    },
    {
      path: '/admin/statistics',
      name: 'AdminStatistics',
      component: Statistics,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) =>
  ((to.name !== 'Home'
  && to.name !== 'Callback'
  && to.name !== 'Rules'
  && to.name !== 'Rating'
  && to.name !== 'MentionsLegales'
  && !iam.isAuthenticated()) ? next('/') : next()),
);


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js